/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorNoticeDto } from '../../models/update-vendor-notice-dto';
import { VendorNoticeDto } from '../../models/vendor-notice-dto';

export interface VendorNoticeControllerUpdate$Params {
  id: string;
      body: UpdateVendorNoticeDto
}

export function vendorNoticeControllerUpdate(http: HttpClient, rootUrl: string, params: VendorNoticeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, vendorNoticeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorNoticeDto>;
    })
  );
}

vendorNoticeControllerUpdate.PATH = '/api/vendor-notice/{id}';
